import { Handler } from '../../../Shared/Application/UseCases/Handler';
import { publicStoreCredentialsHandler } from '../../../Shared/Domain/publicStoreCredentialsHandler';
export class GetRelatedProductsHandler extends Handler {
  constructor(productRepository, authRepository) {
    super();
    this.productRepository = productRepository;
    this.authRepository = authRepository;
  }
  handle(input) {
    if (input.relatedProductReference.type === "FEED_LIST" /* RelatedProductReferenceType.FEED_LIST */) {
      //For feeds we need the store public token to make the request, other types don't need it
      return publicStoreCredentialsHandler(this.authRepository, credentials => this.productRepository.findRelatedProductsByFeed(input.relatedProductReference.references, credentials.accessToken, input.limit ?? 4, input.territory ?? ''));
    }
    return this.productRepository.findRelatedProducts(input.relatedProductReference, input.clientID, input.userID, input.metaproductColors ?? {});
  }
}
